import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProfessionalAudience } from './components/ProfessionalAudience';
import { StatsBar } from './components/StatsBar';
import { TestimonialStrip } from './components/TestimonialStrip';
import { Problems } from './components/Problems';
import { Modules } from './components/Modules';
import { ModuleIncludes } from './components/ModuleIncludes';
import { Comparison } from './components/Comparison';
import { Bonuses } from './components/Bonuses';
import { PricingPack } from './components/PricingPack';
import { Guarantee } from './components/Guarantee';
import { Reviews } from './components/Reviews';
import { CostOfNotBuying } from './components/CostOfNotBuying';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { META_PIXEL_IDS, initMetaPixels } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixels();
  }, []);
  return <main className="w-full overflow-x-hidden bg-mist font-sans text-navy antialiased" data-id="element-0" data-mp="3ikqz80j1f669">
      <noscript data-id="element-1" data-mp="3ml12h5fg3ihf">
        {META_PIXEL_IDS.map(id => <img key={id} height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${id}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="3mjg7xft4rzjk" />)}
      </noscript>
      <Hero data-id="element-3" data-mp="2zm4wkh7vh708" />
      <ProfessionalAudience data-id="element-4" data-mp="2zmem63p09c5e" />
      <StatsBar data-id="element-5" data-mp="2zng1ikd20ksx" />
      <TestimonialStrip data-id="element-6" data-mp="33moqzd129wio" />
      <Problems data-id="element-7" data-mp="33lx02fiesmyq" />
      <Modules data-id="element-8" data-mp="33nggq77z9011" />
      <ModuleIncludes data-id="element-9" data-mp="33myn7icp8zwt" />
      <Comparison data-id="element-10" data-mp="33ohzyyz5cstu" />
      <Bonuses data-id="element-11" data-mp="38m1iwc6shts4" />
      <PricingPack data-id="element-12" data-mp="38li6tc3tlzm0" />
      <Guarantee data-id="element-13" data-mp="38l00tnrcw70w" />
      <Reviews data-id="element-14" data-mp="38kgnylgkc8tq" />
      <CostOfNotBuying data-id="element-15" data-mp="38o4f5dyjcj5a" />
      <FAQ data-id="element-16" data-mp="3dle28mygcipy" />
      <FinalCTA data-id="element-17" data-mp="3dl4ktnrh3jvv" />
      <Footer data-id="element-18" data-mp="3dlnsmbnesrw6" />
    </main>;
}